import { inject, Pipe, PipeTransform } from '@angular/core';
import { ToolsService } from '@app/core/services';

@Pipe({
  name: 'stripHtmlTag',
})
export class StripHtmlTagPipe implements PipeTransform {
  private toolsService: ToolsService = inject(ToolsService);

  transform(value: string): any {
    return this.toolsService.stripHtmlTags(value); // replace tags
  }
}
